module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/45ft-mobile-09b98789f42aa6a1bf8210c347182e31.png";